/* eslint-disable no-param-reassign */
import fetchIntercept from 'fetch-intercept';

const interceptors = (appConfig, router, store) => ({
  // eslint-disable-next-line object-shorthand
  request: (url, config) => {
    if (!url.url) {
      if (!url.includes('http')) {
        url = url.includes('/notifications') ? `${appConfig.liveUrl}${url}` : `${appConfig.apiUrl}${url}`;
      }
      if (!config) {
        // eslint-disable-next-line quote-props
        config = { headers: new Headers({ 'Authorization': `Bearer ${window.$auth.accessToken}` }) }
      } else if (config.headers) {
        if (config.headers.append) {
          config.headers.append('Authorization', `Bearer ${window.$auth.accessToken}`);
        } else if (config.headers.length) {
          config.headers.push(['Authorization', `Bearer ${window.$auth.accessToken}`]);
        } else if (url.includes('service.signalr.net')) {
          console.log(`Connecting to signalr!`);
        } else {
          config.headers.Authorization = `Bearer ${window.$auth.accessToken}`;
        }
      } else {
        // eslint-disable-next-line quote-props
        config.headers = new Headers({ 'Authorization': `Bearer ${window.$auth.accessToken}` })
      } 
    }
    return [url, config];
  },

  // Called when an error occured during another 'request' interceptor call
  requestError: (error) => Promise.reject(error),  
  response: (response) => {
    // TODO: Inspect the response object for 401, 400 or 500
    if (response.status == 401) {
      console.error('401 Unauthorized received from Partner-API. Please relog.');
    }
    if (response.status == 503) {
      response.text().then(() => {
        store.commit('setAppHealth', null);
        if (router?.history?.current?.path != '/maintenance') router.replace('/maintenance');
      });
    }
    return response;
  },

  // Handle an fetch error
  responseError: (error) => Promise.reject(error)
});

export default function RegisterFetchIntercepts(appConfig, router, store) {
  fetchIntercept.register(interceptors(appConfig, router, store));
}
